module.exports = __webpack_public_path__ + "gdu-1bde16f6.webp";